import { Component, forwardRef, Input, SimpleChanges, SimpleChange, OnChanges } from '@angular/core';
import { ControlValueAccessor, FormControl, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-object-picker',
  templateUrl: './object-picker.component.html',
  styleUrls: ['./object-picker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ObjectPickerComponent),
      multi: true
    }
  ]
})

export class ObjectPickerComponent implements ControlValueAccessor, OnChanges {
  @Input() inactive;
  @Input() objects: Array<any>;
  @Input() placeholder = 'Не выбрано';
  @Input() short;
  @Input() groupBy;
  @Input() inputSearch: boolean = false;
  @Input() searchFunction: (query: string) => (item: {[key: string]: any}, index?: number) => boolean;

  form = new FormGroup({
    pickerControl: new FormControl('')
  });

  public groupedObjects = [];
  public data: any;
  public filteredObjects: Array<any> = [];
  private propagateChange = (_: any) => {};

  ngOnInit() {
      this.filteredObjects = [...this.objects];
  }

  public registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  public registerOnTouched() { }

  public writeValue(obj: any) {
    if (obj) {
      this.data = obj;
      this.setControlsState(this.data);
      this.propagateChange(this.data);
    }
  }

  setControlsState(data) {
    for (let i = 0; i < this.filteredObjects.length; i++) {
      if (this.filteredObjects[i].id === data.id) {
        this.form.get('pickerControl').setValue(i);
        break;
      } else {
        this.form.get('pickerControl').setValue('');
      }
    }
  }


  ngOnChanges(changes: SimpleChanges) {
    this.filteredObjects = [...this.objects];
    const objects: SimpleChange = changes.objects;
    this.groupObjects();
    this.modifyObjects(objects);
  }

  onChange(event) {
    if (event !== '') {
      this.writeValue(this.filteredObjects[event]);
    } else {
      this.writeValue({ id: null });
    }
  }

  groupObjects() {
    if (this.groupBy) {
      const notGroupedName = '[без группы]';
      this.filteredObjects.forEach((o, i) => (o.index = i));

      const g = this.filteredObjects.reduce((rv, x) => {
        let normalizedGroupName = (<string>(x[this.groupBy] || '')).trim();
        if (normalizedGroupName === '') {
          normalizedGroupName = notGroupedName;
        }

        rv[normalizedGroupName] = rv[normalizedGroupName] || [];
        rv[normalizedGroupName].push(x);
        return rv;
      }, {});

      this.groupedObjects = [];

      for (const key of Object.keys(g)) {
        this.groupedObjects.push({
          key: key,
          data: g[key]
        });
      }

      this.groupedObjects = this.groupedObjects
        .sort((a, b) => {
          if (a.key > b.key) {
            return 1;
          }
          if (a.key < b.key) {
            return -1;
          }
          return 0;
        })
        .sort((a, b) => {
          if (a.key === notGroupedName) {
            return 1;
          }
          if (b.key === notGroupedName) {
            return -1;
          }
          return 0;
        });
    }
  }

  modifyObjects(objects: any) {
    if (objects) {
      if (!objects.isFirstChange() && objects.previousValue !== objects.currentValue) {
        if (!(<Array<any>>objects.currentValue).includes(this.data)) {
          if (this.filteredObjects.length > 0) {
            this.writeValue(this.filteredObjects[0]);
          }
        }
      }
    }
  }

  onSearch(event: Event) {
    const value = (event.target as HTMLInputElement).value.trim();
    if (value === '') {
      this.filteredObjects = [...this.objects];
    } else {
      const searchFunction = this.searchFunction(value);
      this.filteredObjects = this.objects.filter(searchFunction);
    }

    if (this.groupBy) {
      this.groupObjects();
    }
  }
}
